import { useModal } from '@ebay/nice-modal-react';
import { Fieldset, Select, SubTitle, TextField } from '@repo/ui';
import { ChangeEvent, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import BankListDrawer from '@/components/tax-refund/common/drawers/BankListDrawer';
import { INFOTECH_BANK } from '@/lib/constants/bank';

const BankAccountForm = () => {
  const bankListDrawer = useModal(BankListDrawer);
  const {
    clearErrors,
    setValue,
    register,
    formState: { errors },
    watch,
    trigger
  } = useFormContext();

  const handleClickBank = useCallback(
    (bankId: string) => {
      setValue('bankId', bankId);
      bankListDrawer.hide();
    },
    [bankListDrawer, setValue]
  );

  const handleAccountNumberChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target as HTMLInputElement;
      const newValue = value.replace(/[^0-9]/g, '');
      clearErrors('accountNumber');
      setValue('accountNumber', newValue);
    },
    [clearErrors, setValue]
  );

  return (
    <>
      <SubTitle title={<span className={'font-bold'}>환급 계좌</span>} description={`환급받을 본인 명의 계좌를 입력해주세요.`} size={'large'} />
      <div className="w-full pt-tiny-medium pb-normal-large gap-tiny-large flex flex-col">
        <Select
          selectedValue={INFOTECH_BANK.find(({ bankId }) => bankId === watch('bankId'))?.bankName ?? ''}
          placeholder="은행 선택"
          onClick={() => {
            bankListDrawer.show({ keepMounted: true, onClick: handleClickBank });
          }}
        />
        <Fieldset isInvalid={!!errors?.accountNumber} errorMessage={errors?.accountNumber?.message as string}>
          <TextField
            type="tel"
            inputMode="numeric"
            placeholder="본인 명의 계좌번호 입력"
            className="w-full"
            {...register('accountNumber', {
              onChange: handleAccountNumberChange,
              onBlur: () => {
                trigger('accountNumber');
              }
            })}
            error={!!errors?.accountNumber}
          />
        </Fieldset>
      </div>
    </>
  );
};

export default BankAccountForm;
